// src/pages/NotFound.js - 404 Not Found Page
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isAuthenticated } from '../utils/auth';
import DisclaimerFooter from '../components/common/DisclaimerFooter';

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-shayek-light-50 to-shayek-light-100 dark:from-shayek-dark dark:to-shayek-dark-50 flex items-center justify-center px-4 transition-colors">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-shayek-primary dark:text-shayek-red-light">404</h1>
          <h2 className="text-3xl font-semibold text-shayek-light-900 dark:text-shayek-dark-900 mt-4 mb-2">
            {t('notFound.title') || 'Page Not Found'}
          </h2>
          <p className="text-shayek-light-600 dark:text-shayek-dark-600">
            {t('notFound.message') || 'The page you are looking for does not exist.'}
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-shayek-light-200 dark:bg-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 rounded-lg font-medium hover:bg-shayek-light-300 dark:hover:bg-shayek-dark-300 transition-colors"
          >
            {t('notFound.goBack') || 'Go Back'}
          </button>
          <Link
            to="/"
            className="px-6 py-3 bg-shayek-primary dark:bg-shayek-primary-600 text-white rounded-lg font-medium hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light transition-colors shadow-shayek"
          >
            {t('notFound.goHome') || 'Go Home'}
          </Link>
          {isAuthenticated() && (
            <Link
              to="/dashboard"
              className="px-6 py-3 bg-shayek-primary dark:bg-shayek-primary-600 text-white rounded-lg font-medium hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light transition-colors shadow-shayek"
            >
              {t('notFound.goDashboard') || 'Go to Dashboard'}
            </Link>
          )}
        </div>
      </div>
      <DisclaimerFooter />
    </div>
  );
};

export default NotFound;

